import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import R from 'ramda';
import { Divider } from 'material-ui';
import ForumIcon from 'material-ui/svg-icons/communication/forum';
import { toTitleCase } from 'titlecase';
import { push } from 'react-router-redux';

import {
  loadConvList,
  initialLoadAMsg,
  updateProps,
  toggleConvDone,
} from '../messagingStore/messaging-actions';
import MsgAvatar from '../messaging-avatar';
import TimeNWidget from './timeNWidget';

const propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  convList: PropTypes.array,
  decrementUnreadCount: PropTypes.func,
  hoveredConv: PropTypes.object,
  initialLoadAMsg: PropTypes.func,
  loadConvList: PropTypes.func,
  loadingConvList: PropTypes.bool,
  params: PropTypes.object,
  push: PropTypes.func,
  selectedChannel: PropTypes.string,
  selectedContract: PropTypes.string,
  selectedConv: PropTypes.object,
  toggleConvDone: PropTypes.func,
  updateProps: PropTypes.func,
  viewerCompany: PropTypes.object,
};

const styles = {
  main: {
    width: '334px !important',
    marginTop: '0',
    '& > div': {
      position: 'relative',
      top: 0,
      height: '85%',
      overflowY: 'scroll',
    },
  },
  participanName: {
    flexGrow: '2',
    color: 'rgba(0, 0, 0, 0.74)',
    paddingLeft: '4px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontWeight: '600',
    '&.hasSeen': {
      fontWeight: '500',
    },
  },
  emptyConvs: {
    textAlign: 'center',
    marginTop: '50%',
  },
  forumIcon: {
    color: 'rgba(0, 0, 0, 0.24)',
    height: '48px',
    width: '48px',
  },
  aConv: {
    cursor: 'pointer',
    padding: '8px 16px',
    '&.selected': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
  },
  latestMessage: {
    fontWeight: '600',
    fontSize: '12px',
    margin: '8px 0 0 4px',
    lineHeight: '17px',
    maxHeight: '34px',
    minHeight: '17px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.seen': {
      fontWeight: '500',
    },
  },
  channelsTitle: {
    color: 'white',
    fontSize: '18px',
    flex: '1 0 auto',
    lineHeight: '48px',
    paddingLeft: '10px',
    backgroundColor: 'rgb(0, 179, 207)',
    height: '48px !important',
  },
};

class ConversationList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hoveredConv: {},
    };
  }
  componentWillMount() {
    const { selectedChannel } = this.props;
    this.props.loadConvList('notdone', !Boolean(selectedChannel));
  }
  componentDidMount() {
    if (!this.timer) this.timer = setInterval(this.timedUpdate, 4e3);
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  timer = null
  timedUpdate = () => {
    const { loadingConvList, selectedChannel } = this.props;
    if (!localStorage.stopAutoReload && !loadingConvList) this.props.loadConvList('notdone', !Boolean(selectedChannel));
  }

  openAConv = (conv) => {
    const { decrementUnreadCount } = this.props;
    if (!conv.hasSeen) decrementUnreadCount();
    // since now this area is only for self forwarding
    // one conv is one message from workspacemessages
    this.props.updateProps('convs', { selectedConv: conv, messages: [conv] });
    this.props.updateProps('messages', { conv, list: [conv], messagesLoaded: true });
    this.props.push(`/workspace/inbox/${conv.messageId}`);
  };

  render() {
    const {
      classes,
      className,
      convList,
      loadingConvList,
      params,
      selectedChannel,
      selectedContract,
      viewerCompany,
    } = this.props;
    const { hoveredConv } = this.state;
    const emptyConvs = Boolean(!loadingConvList && R.isEmpty(convList));
    const paramsFilter = params.filter || 'notdone';
    return (
      <div className={`l-left-nav ${className} ${classes.main}`}>
      <div className={classes.channelsTitle}>Unassigned</div>
        <div>
          {
            emptyConvs && (<div className={classes.emptyConvs}>
              <ForumIcon className={classes.forumIcon}/>
              <h4 style={{ color: 'rbga(0, 0, 0, 0.44)' }}>No {paramsFilter === 'notdone' ? '' : toTitleCase(paramsFilter)} Conversations</h4>
            </div>)
          }
          {
            !R.isEmpty(convList) && R.sort(R.descend(R.prop('updatedAt')), convList).map((conv, convIndex) => {
              // if both participant are viewers, they sent msg to themselves
              // const participant = (() => {
              //   if (conv.contractId) return { name: conv.contractName, type: 'contract' };
              //   const recipients = R.reject(R.propEq('isViewer', true), conv.participants);
              //   return recipients[0] || viewerCompany;
              // })();
              const isSelected = conv.messageId === selectedChannel || (selectedContract && conv.contractId === selectedContract);
              const isHovered = conv.messageId === hoveredConv.messageId;
              return (
                <div key={conv.messageId} style={convIndex === convList.length - 1 ? { marginBottom: '44px' } : {}}>
                  <div
                    className={`${classes.aConv}${isSelected ? ' selected' : ''}`}
                    onClick={isSelected ? () => {} : () => this.openAConv(conv)}
                    onMouseEnter={() => this.setState({ hoveredConv: conv })}
                    onMouseLeave={() => this.setState({ hoveredConv: {} })}
                  >
                    <div className="flex-tc-sb">
                      <div style={{ display: 'flex', alignItems: 'center', width: '70%' }}>
                        {/*<MsgAvatar {...participant} />*/}
                        <span className={`${classes.participanName}`}>{conv.creatorEmail}</span>
                      </div>
                      {/* <AvatarName hasSeen={conv.hasSeen} participant={participant} classes={classes}/> */}
                      <TimeNWidget
                        toggleDone={val => this.setState({ hoveredDone: val })}
                        isHovered={isHovered}
                        hoveredDone={this.state.hoveredDone}
                        conv={conv}
                        markAsDone={this.props.toggleConvDone}
                        classes={classes}
                      />
                    </div>
                    <div className={`${classes.latestMessage}${conv.hasSeen ? ' seen' : ''}`}>
                      {conv.subject}
                    </div>
                  </div>
                  <Divider/>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ messaging, user, workspace }) => (
  {
    ...messaging.conversations.toJS(),
    viewerCompany: {
      id: user.toJS().company.companyId,
      name: user.toJS().company.companyName,
      avatarUrl: user.toJS().company.profileImageUrl,
      type: 'account',
    },
    selectedChannel: workspace.selectedChannel,
    selectedContract: workspace.selectedContract,
  }
);

ConversationList.propTypes = propTypes;
export default connect(mapStateToProps, {
  decrementUnreadCount: () => ({ type: 'DECREMENT_UNREAD_MESSAGES_COUNT' }),
  initialLoadAMsg,
  loadConvList,
  push,
  toggleConvDone,
  updateProps,
})(injectSheet(styles)(ConversationList));



// WEBPACK FOOTER //
// ./src/app/components/messaging/conversations/convsContainer.jsx